var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.talentLoading,
          expression: "talentLoading",
        },
      ],
      staticStyle: { "min-height": "200px" },
    },
    [
      _vm.orgData && _vm.orgData.length && !_vm.talentLoading
        ? _c(
            "div",
            _vm._l(_vm.orgData, function (item, i) {
              return _c("div", { key: i, staticClass: "person-item" }, [
                _c(
                  "div",
                  {
                    staticStyle: { "margin-left": "8px" },
                    on: {
                      click: function ($event) {
                        return _vm.goOrgDetails(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "person-name" }, [
                      _vm._v(" " + _vm._s(item.nameCn) + " "),
                    ]),
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v(" 所在地:"),
                      _c(
                        "span",
                        {
                          staticClass: "item-num",
                          staticStyle: {
                            "margin-right": "9px",
                            color: "#50607F",
                          },
                        },
                        [_vm._v(_vm._s(item.province || "-"))]
                      ),
                      item.province && item.city
                        ? _c("span", { staticStyle: { color: "#50607F" } }, [
                            _vm._v(_vm._s(item.city)),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v(" 专利数:"),
                      _c(
                        "span",
                        {
                          staticClass: "item-num",
                          staticStyle: { "margin-right": "9px" },
                        },
                        [_vm._v(_vm._s(item.pubCount[1].count || "0"))]
                      ),
                      _vm._v(" 论文数:"),
                      _c("span", { staticClass: "item-num" }, [
                        _vm._v(_vm._s(item.pubCount[0].count || "0")),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v("主要技术领域: "),
                      !item.fieldList || item.fieldList.length === 0
                        ? _c("span", { staticClass: "item-right" }, [
                            _vm._v("-"),
                          ])
                        : _vm._e(),
                      item.fieldList && item.fieldList?.length > 5
                        ? _c("span", { staticClass: "item-right" }, [
                            _vm._v(_vm._s(item.fieldList.slice(0, 5)) + "..."),
                          ])
                        : _c("span", { staticClass: "item-right" }, [
                            _vm._v(_vm._s(item.fieldList?.join(",") || "")),
                          ]),
                    ]),
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v("主要研究方向: "),
                      !item.interestList || item.interestList.length === 0
                        ? _c("span", { staticClass: "item-right" }, [
                            _vm._v("-"),
                          ])
                        : item.interestList && item.interestList?.length > 5
                        ? _c("span", { staticClass: "item-right" }, [
                            _vm._v(
                              _vm._s(item.interestList.slice(0, 5)) + "..."
                            ),
                          ])
                        : _c("span", { staticClass: "item-right" }, [
                            _vm._v(_vm._s(item.interestList?.join(",") || "")),
                          ]),
                    ]),
                  ]
                ),
              ])
            }),
            0
          )
        : _c("div", [_c("el-empty")], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }